import { CommonStyles } from '~common/react/CommonStyles';
import { cssClass } from '~src/style';
import { SettingsStyles } from '~src/settings/styles/CommonStyles';

const SALESFORCE_SETTINGS_PREFIX = 'salesforce-settings';
const SETTINGS_CONTAINER_INDENT = '85px';

export const salesforceSettingsContainer = cssClass(SALESFORCE_SETTINGS_PREFIX,'container', {
  marginLeft: SETTINGS_CONTAINER_INDENT,
  paddingBottom: CommonStyles.Sizes.DefaultSpace,
  paddingTop: CommonStyles.Sizes.XLargeSpace,
  maxWidth: '508px'
});

export const salesforceSettingsConnectButton = cssClass(SALESFORCE_SETTINGS_PREFIX,'connect-button', {
  marginBottom: CommonStyles.Sizes.LineHeight,
});

export const salesforceSettingsGroupName = cssClass(SALESFORCE_SETTINGS_PREFIX,'group-name', {
  paddingBottom: CommonStyles.Sizes.MediumSpace,
  fontSize: CommonStyles.Sizes.NormalFontSize,
  margin: 0,
});

export const integrationsSettingsPageHeader = cssClass(SALESFORCE_SETTINGS_PREFIX,'page-header', {
  ...SettingsStyles.settingsGroupNameProperties,
  paddingBottom: CommonStyles.Sizes.LineHeight,
  margin: 0,
});

export const salesforceSettingsParagraph = cssClass(SALESFORCE_SETTINGS_PREFIX,'paragraph', {
  margin: 0,
  paddingBottom: CommonStyles.Sizes.LineHeight,
});

export const salesforceSettingsGroupContainer = cssClass(SALESFORCE_SETTINGS_PREFIX,'group-container', {
  paddingBottom: CommonStyles.Sizes.LargeSpace,
  paddingLeft: CommonStyles.Sizes.LargeSpace,
});
